// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSwitch-StyledSwitch_cls1__KZss7","cls2":"VeloSwitch-StyledSwitch_cls2__Si24l VeloSwitch-StyledSwitch_cls1__KZss7"};